import { Image } from '../../../shared/shared.interface';

export interface KngButton {
  state: KngButtonState;
}

export interface KngButtonState {
  size: KngButtonSize;
  style: KngButtonStyle;
  disabled: boolean;
  label: string;
  position: KngButtonPosition;
  icon: Image;
}

export type KngButtonSize = 'small' | 'medium' | 'large';
export type KngButtonStyle =
  | 'primary'
  | 'secondary'
  | 'destructive'
  | 'secondary-destructive'
  | 'tertiary'
  | 'link'
  | 'link-primary';
export type KngButtonPosition = 'left' | 'right' | 'none';
